import { Button, ErrorBlock } from "antd-mobile";
import "./404.less";
import { useNavigate } from "react-router-dom";
// import { useEffect } from "react";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <ErrorBlock status="empty" title="哎呀，您访问的页面打不开啦！" />
      <p className="btn-group">
        <Button color="primary" onClick={() => navigate("/")}>
          前往首页
        </Button>
      </p>
    </div>
  );
}
